import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AddressingLineNotificationTitle = styled.span`
  display: block;
  margin-bottom: ${Spacing.S6};
`
